import { z } from 'zod';

export const schemaResetPassword = z
    .object({
        password: z.string().min(1),
        passwordRepeat: z.string().min(1),
    })
    .refine((schema) => schema.password === schema.passwordRepeat, {
        message: "Passwords don't match",
        path: ['both'],
    });
export type SchemaResetPassword = z.infer<typeof schemaResetPassword>;
